export enum ClaimStatusType {
  Open = 1,
  Closed = 2,
}

export enum PaymentFrequency
{
    Monthly = 1,
    Quarterly = 2,
    SixMonth = 3,
    Annually = 4
}

export const PaymentFrequencyDisplayMap: { [key in keyof typeof PaymentFrequency]?: string } = {
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  SixMonth: 'Six Month',
  Annually: 'Annually'
};

export enum CoverageValueRangeType {
  SingleDropDown = 1,
  DoubleDropDown = 2,
}

export const CoverageValueRangeTypeDisplayMap: { [key in keyof typeof CoverageValueRangeType]?: string } = {
  SingleDropDown: 'Single DropDown',
  DoubleDropDown: 'Double DropDown',
}

export enum LeadPurchaseGenerateBy {
  Customer = 1,
  Agent = 2,
  CallCenter = 3,
  SelfSignup = 4,
}

export const LeadPurchaseGenerateBydispalayMap: { [key in keyof typeof LeadPurchaseGenerateBy]?: string } = {
  Agent: 'Firm/Agent(Create Profile)',
  Customer: 'Firm/Agent(Email link)',
  CallCenter: 'Call Center',
  SelfSignup: 'Self Signup',
}

export enum CustomerInterest {
  Selected = 2,
  Declined = 3,
  DealMade = 4,
  Won = 7,
  Lost = 8
}

export const CustomerInterestDisplayMap: { [key in keyof typeof CustomerInterest]?: string } = {
  Selected: 'Selected',
  Declined: 'Declined',
  DealMade: 'Deal Made',
  Won: 'Deal Made',
  Lost: 'Deal Made'
}


export enum LeadStatus
{
    SaveAsDraft = 1,
    Open = 2,
    Close = 3,
    MatchReceived = 4,
    InProgress = 5,
    DealMade = 6,
    LostLead = 7,
}

export const LeadStatusdispalayMap: { [key in keyof typeof LeadStatus]?: string } = {
  SaveAsDraft : 'SaveAsDraft',
  Open : 'Open',
  Close :'Close',
  MatchReceived : 'Match Received',
  InProgress : 'In Progress',
  DealMade :'Deal Made',
  LostLead :'Lost Lead'
}

export enum QuoteStatus{
  Submitted = 1,
  Selected = 2,
  Declined = 3,
  DealMade = 4,
  InProgress = 5,
  NotEligible = 6,
  Won = 7,
  Lost = 8
}

export const QuoteStatusdispalayMap: { [key in keyof typeof QuoteStatus]?: string } = {
  Submitted : 'Submitted',
  Selected : 'Selected',
  Declined :'Declined',
  DealMade : 'Deal Made',
  InProgress : 'In Progress',
  NotEligible :'Not Eligible',
  Won:'Won',
  Lost:'Lost'
}

export enum CustomerRegisterMenuType{
  PrimaryInsured = 1,
  LicensedDriver = 2,
  DrivingRecord = 3,
  VehicleInformation = 4,
  BankOrLienHolderInfo = 5,
  Insurer = 6,
  CoverageLimit = 7,
  ContactPreference = 8,
  UploadDocuments = 9
}

export enum SweetSpotMenuType{
  Demographics = 1,
  Geographic = 2,
  HouseHoldStatus = 3,
  DrivingRecord = 4,
  VehicleInformation = 5,
  CurrentCarrierHistory = 6,
  CoverageLimit = 7,
  SweetspotsApplicability = 8,
  CustomerContactPreference = 9,
  LeadGenerationSource = 10
}

export enum SweetSpotSubheaderMenuType{
  martialStatus = 1,
  gender = 2,
  HouseHoldStatus = 3,
  DrivingRecord = 4,
  VehicleInformation = 5,
  CurrentCarrierHistory = 6,
  CoverageLimit = 7,
  SweetspotsApplicability = 8,
  CustomerContactPreference = 9,
  LeadGenerationSource = 10
}